import * as React from 'react';

import type {
    GetPlanComparisons_planComparisons_featureGroups as FeatureGroups,
    GetPlanComparisons_planComparisons_planStubs as PlanStub,
} from 'nutshell-graphql-types';

import {FeatureGroup} from './plan-comparison-feature-group';
import {PlanComparisonTableHeader} from './plan-comparison-table-header';

import styles from './plan-comparison-table.module.css';

type Props = {
    features: FeatureGroups[];
    plans: PlanStub[];
};

// Standalone table for comparing features across plans.
// NOTE: This is used on nutshell.com as an embedded component - thread carefully!
export function PlanComparisonTable(props: Props): React.ReactElement {
    return (
        <table className={styles['plan-comparison-table-new']}>
            <PlanComparisonTableHeader plans={props.plans} />
            <tbody>
                {props.features.map((featureGroup: FeatureGroups) => {
                    return (
                        <FeatureGroup
                            key={featureGroup.title}
                            featureGroup={featureGroup}
                            numPlans={props.plans.length}
                        />
                    );
                })}
            </tbody>
        </table>
    );
}
